

import React, { useState, useEffect } from "react";
import {
  Box, Typography, Card, CardContent, Avatar, IconButton, TextField, Button,
  Dialog, DialogTitle, DialogContent, DialogActions,Container,Paper,
  Link, InputAdornment, MenuItem, Divider, Grid, Chip
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete"; 
import UploadFileIcon from "@mui/icons-material/UploadFile";
import PersonIcon from "@mui/icons-material/Person";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import DescriptionIcon from "@mui/icons-material/Description";
import HomeIcon from "@mui/icons-material/Home";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import LogoutIcon from "@mui/icons-material/Logout";
import addressConfig from "../../../Configurations/addressConfig.json";
import { apiRequest } from '../../../fetchSetup';
import { useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";

import {fetchUserFromRedis} from "../AuthonticationScreens/Register";
const COMMUNITY_OPTIONS = addressConfig.communities;
const BLOCK_OPTIONS = addressConfig.blocks;
const ProfilePage = () => {
  const navigate=useNavigate()
  const [user, setUser] = useState(null);
  const [editMode, setEditMode] = useState(false);
 const [errors, setErrors] = useState({  addressPhone: "",
  alternatePhone: ""});
 const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    age: "", 
    gender: "",
    address: {
      full_name: "",
      phone: "",
      community_name: "",
      address_line1: "",
      address_line2: "",
      landmark: "",
      city: "",
      state: "",
      pincode: "",
      address_type: "home"
    },
    emergency_contacts: [{ name: "", phone: "" }],
    family_members: [{ name: "", relation: "", age: "", gender: "" }],
    documents: [{ type: "", file_url: [] }],
  });

  const [validationDialogOpen, setValidationDialogOpen] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const [passwordDialog, setPasswordDialog] = useState(false);
  const [passwordData, setPasswordData] = useState({ new_password: "", confirm_password: "" });
  const [showPassword, setShowPassword] = useState({ new: false, confirm: false });
  const { setUsername } = useOutletContext();

  const getUserAPI = process.env.REACT_APP_GET_USER_DETAILS_API;
  const updateProfileAPI = process.env.REACT_APP_UPDATE_USER_PROFILE_API;
  const changePasswordAPI = process.env.REACT_APP_CHANGE_PASSWORD_API;
  const fileUploadAPI = process.env.REACT_APP_FILEUPLOAD_API;

  // Fetch user on mount
  useEffect(() => {
    const fetchUser = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) return;

      try {
        const res = await apiRequest(getUserAPI, {
          method: "GET",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        
        if (res.ok) {
          // Parse emergency contacts
          const emergency_contacts = (data.user.emergency_contacts || []).map(c =>
            typeof c === "string" ? { name: c.split(":")[0], phone: c.split(":")[1] } : c
          );
          
          // Parse family members
          const family_members = (data.user.family_members || []).map(m =>
            typeof m === "string" ? { 
              name: m.split(":")[0], 
              relation: m.split(":")[1], 
              age: m.split(":")[2], 
              gender: m.split(":")[3] 
            } : m
          );
          
          // Parse documents
            const documents = (data.user.documents || []).map(d => ({
              type: d.type || "",
              // Use file_urls from backend (it's an array)
              file_url: Array.isArray(d.file_urls) ? d.file_urls : [],
            })); 

          // Parse address - handle both object and null cases
          const address = data.user.address ? {
            full_name: data.user.address.full_name || "",
            phone: data.user.address.phone || "",
            community_name: data.user.address.community_name || "",
            address_line1: data.user.address.address_line1 || "",
            address_line2: data.user.address.address_line2 || "",
            landmark: data.user.address.landmark || "",
            city: data.user.address.city || "",
            state: data.user.address.state || "",
            pincode: data.user.address.pincode || "",
            address_type: data.user.address.address_type || "home"
          } : {
            full_name: "",
            phone: "",
            community_name: "",
            address_line1: "",
            address_line2: "",
            landmark: "",
            city: "",
            state: "",
            pincode: "",
            address_type: "home"
          };

          setUser(data.user);
          setFormData({
            name: data.user.name || "",
            email: data.user.email || "",
            phone: data.user.phone || "",
            age: data.user.age || "",
            gender: data.user.gender || "",
            address: address,
            emergency_contacts: emergency_contacts.length ? emergency_contacts : [{ name: "", phone: "" }],
            family_members: family_members.length ? family_members : [{ name: "", relation: "", age: "", gender: "" }],
            documents: documents.length ? documents : [{ type: "", file_url: [] }],
          });
        } else {
          setValidationMessage(data.error);
          setValidationDialogOpen(false);
        }
      } catch (err) {
        setValidationMessage("Failed to fetch user data!");
        setValidationDialogOpen(true);
      }
    };
    fetchUser();
  }, []);

  const validatePhone = (phone) => {
  if (!phone) return "Phone number is required";
  if (phone.length !== 10) return "Phone number must be 10 digits";
  return "";
};

const validateName = (name) => {
  if (!name.trim()) return "Full Name is required";

  // Only letters + spaces, min 2 chars
  if (!/^[A-Za-z ]{1,}$/.test(name.trim())) {
    return "Enter a valid name (only letters, min 1 characters)";
  }

  return "";
};
// Add this function near your other handlers (after handleCancel or before handleSaveProfile)
const handleCancelEdit = () => {
  if (!user) return;
  
  // Reset formData to original user data
  const emergency_contacts = (user.emergency_contacts || []).map(c =>
    typeof c === "string" ? { name: c.split(":")[0], phone: c.split(":")[1] } : c
  );
  
  const family_members = (user.family_members || []).map(m =>
    typeof m === "string" ? { 
      name: m.split(":")[0], 
      relation: m.split(":")[1], 
      age: m.split(":")[2], 
      gender: m.split(":")[3] 
    } : m
  );
  
  const documents = (user.documents || []).map(d => ({
    type: d.type || "",
    file_url: Array.isArray(d.file_urls) ? d.file_urls : [],
  })); 

  const address = user.address ? {
    full_name: user.address.full_name || "",
    phone: user.address.phone || "",
    community_name: user.address.community_name || "",
    address_line1: user.address.address_line1 || "",
    address_line2: user.address.address_line2 || "",
    landmark: user.address.landmark || "",
    city: user.address.city || "",
    state: user.address.state || "",
    pincode: user.address.pincode || "",
    address_type: user.address.address_type || "home"
  } : {
    full_name: "",
    phone: "",
    community_name: "",
    address_line1: "",
    address_line2: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
    address_type: "home"
  };

  setFormData({
    name: user.name || "",
    email: user.email || "",
    phone: user.phone || "",
    age: user.age || "",
    gender: user.gender || "",
    address: address,
    emergency_contacts: emergency_contacts.length ? emergency_contacts : [{ name: "", phone: "" }],
    family_members: family_members.length ? family_members : [{ name: "", relation: "", age: "", gender: "" }],
    documents: documents.length ? documents : [{ type: "", file_url: [] }],
  });
  
  // Close edit mode
  setEditMode(false);
};
  const uploadFile = async (file, type, token) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type || "Other");
    
    console.log("Uploading file:", file.name, "type:", type);
    
    try {
      const res = await apiRequest(fileUploadAPI, {
        method: "POST",
        headers: { 
          Authorization: `Bearer ${token}` 
        },
        body: formData,
      });
      
      const data = await res.json();
      console.log("Upload API Response - FULL:", data);
      
      if (!res.ok) {
        throw new Error(data.error || `Upload failed with status: ${res.status}`);
      }
      
      // Get ALL file URLs that might be returned
      let fileUrls = [];
      
      // Check different possible response formats
      if (Array.isArray(data.file_urls)) {
        fileUrls = data.file_urls;
      } else if (data.data?.file_urls && Array.isArray(data.data.file_urls)) {
        fileUrls = data.data.file_urls;
      } else if (data.file_url) {
        fileUrls = [data.file_url]; // Single URL, wrap in array
      } else if (data.data?.file_url) {
        fileUrls = [data.data.file_url];
      } else if (data.data?.cloudfront_url) {
        fileUrls = [data.data.cloudfront_url];
      } else if (data.cloudfront_url) {
        fileUrls = [data.cloudfront_url];
      }
      
      console.log("Found file URLs:", fileUrls);
      
      if (fileUrls.length === 0) {
        console.error("No file URLs found in response");
        throw new Error("Server did not return file URLs");
      }
      
      return fileUrls; // Return array of URLs
      
    } catch (error) {
      console.error("Upload function error:", error);
      throw error;
    }
  };

  const handleChange = e =>
    { setFormData({ ...formData, [e.target.name]: e.target.value })
          if (e.target.name === "name") {
          const error = validateName(e.target.value);
          setErrors((prev) => ({ ...prev, name: error }));
  }

    };

  // Handle address field changes
  const handleAddressChange = (field, value) => {
    setFormData({
      ...formData,
      address: {
        ...formData.address,
        [field]: value
      }
    });
    if (field === "full_name") {
          const error = validateName(value);
          setErrors((prev) => ({ ...prev, full_name: error }));
  };
}

  const handleEmergencyChange = (index, field, value) => {
    const updated = [...formData.emergency_contacts];
    updated[index][field] = value;
    setFormData({ ...formData, emergency_contacts: updated });
  };

  const handleFamilyChange = (index, field, value) => {
    const updated = [...formData.family_members];
    updated[index][field] = value;
    setFormData({ ...formData, family_members: updated });
  };

  const handleDocumentChange = async (index, field, value) => {
    const updated = [...formData.documents];
    const token = sessionStorage.getItem("token");
  
    if (field === "files") {
      const files = Array.from(value);
      try {
        // Upload all files and get arrays of URLs
        const uploadedURLArrays = await Promise.all(
          files.map(file => uploadFile(file, updated[index].type, token))
        );
        
        // DEBUG: Log what we're getting back
        console.log("Uploaded URL arrays:", uploadedURLArrays);
        
        // Flatten all arrays into one
        const allUploadedURLs = uploadedURLArrays.flat();
        
        if (!updated[index].file_url) {
          updated[index].file_url = [];
        }
        
        // Append all new URLs
        updated[index].file_url = [...updated[index].file_url, ...allUploadedURLs];
        
        console.log("Updated document file_urls:", updated[index].file_url);
      } catch (err) {
        setValidationMessage(err.message);
        setValidationDialogOpen(true);
        console.error("Upload error:", err);
      }
    } else if (field === "type") {
      updated[index].type = value;
    }
    
    // DEBUG: Log the updated document
    console.log("Updated document:", updated[index]);
    
    setFormData({ ...formData, documents: updated });
  };



  const handleSaveProfile = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await apiRequest(updateProfileAPI, {
        method: "PUT",
        headers: { 
          "Content-Type": "application/json"
          
        },
        body: JSON.stringify(formData),
      });
      
      const data = await res.json();
      
      if (res.ok) {
        //  CHANGED: Access user from data.user instead of data.data
        const updatedUser = data.user || data.data;  // Fallback for both structures
        setUser(updatedUser);
        setUsername(updatedUser.name);
        setEditMode(false);
        
        setValidationMessage("Profile updated successfully!");
        setValidationDialogOpen(true);
        
        //  Optional: Force reload user data to ensure sync
        const userId = sessionStorage.getItem("userId");
        if (userId) {
          const freshUserData = await fetchUserFromRedis(userId, token);
          if (freshUserData) {
            setUser(freshUserData);
          }
        }
       
      
      } else {
        if (data.error?.includes("gender.Value must be one of")) {
          setValidationMessage("Please check the family details. Some required fields are missing.");
        } else {
          setValidationMessage(data.error);
        }
        setValidationDialogOpen(true);
      }
    } catch (err) {
      setValidationMessage("Something went wrong!");
      setValidationDialogOpen(true);
    }
  };

  

  const handleChangePassword = async () => {
    if (passwordData.new_password !== passwordData.confirm_password) {
      setValidationMessage("Passwords do not match!");
      setValidationDialogOpen(true);
      return;
    }
    try {
      const token = sessionStorage.getItem("token");
      const res = await apiRequest(changePasswordAPI, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(passwordData),
      });
      const data = await res.json();
      if (res.ok) {
        setValidationMessage("Password updated successfully!");
        setValidationDialogOpen(true);
        setPasswordDialog(false);
        setPasswordData({ new_password: "", confirm_password: "" });
      } else {
        setValidationMessage(data.error);
        setValidationDialogOpen(true);
      }
    } catch (err) {
      setValidationMessage("Something went wrong!");
      setValidationDialogOpen(true);
    }
  };

  const handleLogout = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const userId = sessionStorage.getItem("userId");
      const logoutapi = process.env.REACT_APP_LOGOUT_API;
      await apiRequest(`${logoutapi}/${userId}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      sessionStorage.clear();
      navigate("/Login");
    }
  };

  return (
    <>
     <Paper elevation={2} sx={{ bgcolor: "#fff", mb: 3 }}>
  <Container maxWidth="lg">
    <Box
      sx={{
        py: { xs: 1.5, sm: 2, md: 3 },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
      }}
    >
      {/* LEFT — Back Button */}
      <IconButton
        onClick={() => window.history.back()}
        sx={{
          backgroundColor: "white",
          boxShadow: 1,
          "&:hover": { backgroundColor: "#f5f5f5" },
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      {/* CENTER — Title */}
      <Typography
        variant="h4"
        sx={{
          color: "#006D77",
          fontWeight: 600,
          fontSize: { xs: "1rem", sm: "1.4rem", md: "2rem" },
          textAlign: "center",
          flex: 1,
        }}
      >
        Profile Management
      </Typography>

      {/* RIGHT — Logout Button */}
      <Button
        startIcon={<LogoutIcon />}
        onClick={() => setLogoutDialogOpen(true)}
        sx={{
          textTransform: "none",
          borderColor: "#d32f2f",
          color: "#d32f2f",
          fontWeight: 700,
          fontSize:20,
          px: 1,
          whiteSpace: "nowrap",
          "&:hover": {
            borderColor: "#d32f2f",
            backgroundColor: "rgba(211, 47, 47, 0.06)",
          },
        }}
      >
        Logout
      </Button>
    </Box>
  </Container>
</Paper>
      
      <Box sx={{ maxWidth: 900, mx: "auto", px: 2 }}>
    
        {/* Profile Header Card */}

          <Card sx={{ mb: 3, borderRadius: 2, boxShadow: 2 }}>
            <Box
              sx={{
                background: "linear-gradient(135deg, #006D77 0%, #83C5BE 100%)",
                p: { xs: 2, sm: 3, md: 4 },
                position: "relative",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: { xs: "flex-start", sm: "center" },
                  justifyContent: "space-between",
                  gap: { xs: 1.5, sm: 3 },
                }}
              >
                {/* Avatar + Info */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: { xs: "flex-start", sm: "center" },
                    gap: { xs: 2, sm: 3 },
                    flex: 1,
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: "white",
                      color: "#006D77",
                      width: { xs: 60, sm: 80, md: 100 },
                      height: { xs: 60, sm: 80, md: 100 },
                      fontSize: { xs: 24, sm: 32, md: 40 },
                      fontWeight: 600,
                      boxShadow: 3,
                      flexShrink: 0,
                    }}
                  >
                    {formData.name?.charAt(0)?.toUpperCase()}
                  </Avatar>

                  <Box>
                    <Typography
                      variant="h5"
                      sx={{
                        color: "white",
                        fontWeight: 600,
                        mb: 0.5,
                        fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                        wordBreak: "break-word",
                      }}
                    >
                      {formData.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "rgba(255,255,255,0.9)",
                        fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        wordBreak: "break-word",
                      }}
                    >
                      {formData.email}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "rgba(255,255,255,0.9)",
                        fontSize: { xs: "0.75rem", sm: "0.875rem" },
                      }}
                    >
                      {formData.phone}
                    </Typography>
                  </Box>
                </Box>

                {/* Edit/Cancel Button */}
                <IconButton
                  onClick={() => {
                    if (editMode) {
                      handleCancelEdit();
                    } else {
                      setEditMode(true);
                    }
                  }}
                  sx={{
                    backgroundColor: "white",
                    color: "#006D77",
                    flexShrink: 0,
                    width: { xs: 36, sm: 44 },
                    height: { xs: 36, sm: 44 },
                    alignSelf: { xs: "flex-start", sm: "center" },
                    "&:hover": { backgroundColor: "#f5f5f5" },
                  }}
                >
                  {editMode ? (
                    <CancelIcon sx={{ fontSize: { xs: 18, sm: 24 } }} />
                  ) : (
                    <EditIcon sx={{ fontSize: { xs: 18, sm: 24 } }} />
                  )}
                </IconButton>
              </Box>
            </Box>
          </Card>

        {/* Main Content */}
        <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
          <CardContent sx={{ p: 4 }}>
            {/* Personal Information Section */}
            <Box sx={{ mb: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <PersonIcon sx={{ color: "#006D77", mr: 1, fontSize: 28 }} />
                <Typography variant="h6" sx={{ color: "#006D77", fontWeight: 600 }}>
                  Personal Information
                </Typography>
              </Box>
              <Divider sx={{ mb: 3 }} />

              {editMode ? (
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField 
                      label="Full Name" 
                      name="name" 
                      value={formData.name} 
                      onChange={handleChange} 
                      fullWidth 
                      variant="outlined"
                      error={!!errors.name}
                      helperText={errors.name}
                      sx={{ backgroundColor: "white" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField 
                      label="Email Address" 
                      name="email" 
                      value={formData.email} 
                      onChange={handleChange} 
                      fullWidth 
                      disabled
                      variant="outlined"
                      sx={{ backgroundColor: "#f9f9f9" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField 
                      label="Phone Number" 
                      name="phone" 
                      value={formData.phone} 
                      onChange={handleChange} 
                      fullWidth 
                      disabled
                      variant="outlined"
                      sx={{ backgroundColor: "#f9f9f9" }}
                    />
                  </Grid>

                <Grid item xs={12} md={3}>
                    <TextField 
                      label="Age" 
                      name="age" 
                      value={formData.age} 
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d{0,3}$/.test(val)) {
                          handleChange(e);
                        }
                      }}
                      fullWidth 
                      variant="outlined"
                      inputProps={{ maxLength: 3 }}
                      sx={{ backgroundColor: "white" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField 
                      select
                      label="Gender" 
                      name="gender" 
                      value={formData.gender} 
                      onChange={handleChange} 
                      fullWidth 
                      variant="outlined"
                      sx={{ backgroundColor: "white", minWidth: 200, }}

                    >
                      <MenuItem value="">Select</MenuItem>
                      <MenuItem value="male">Male</MenuItem>
                      <MenuItem value="female">Female</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                    </TextField>
                  </Grid>

                </Grid>
              ) : (
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Box sx={{ p: 2, backgroundColor: "#f9f9f9", borderRadius: 1 }}>
                      <Typography variant="caption" sx={{ color: "#666", textTransform: "uppercase", fontSize: 10 }}>
                        Full Name
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
                        {formData.name}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box sx={{ p: 2, backgroundColor: "#f9f9f9", borderRadius: 1 }}>
                      <Typography variant="caption" sx={{ color: "#666", textTransform: "uppercase", fontSize: 10 }}>
                        Email Address
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
                        {formData.email}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box sx={{ p: 2, backgroundColor: "#f9f9f9", borderRadius: 1 }}>
                      <Typography variant="caption" sx={{ color: "#666", textTransform: "uppercase", fontSize: 10 }}>
                        Phone Number
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
                        {formData.phone}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Box sx={{ p: 2, backgroundColor: "#f9f9f9", borderRadius: 1 }}>
                      <Typography variant="caption" sx={{ color: "#666", textTransform: "uppercase", fontSize: 10 }}>
                        Age
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
                        {formData.age || "Not specified"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box sx={{ p: 2, backgroundColor: "#f9f9f9", borderRadius: 1 }}>
                      <Typography variant="caption" sx={{ color: "#666", textTransform: "uppercase", fontSize: 10 }}>
                        Gender
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5, textTransform: "capitalize" }}>
                        {formData.gender || "Not specified"}
                      </Typography>
                    </Box>
                  </Grid>

                </Grid>
              )}
            </Box>

            {/* Delivery Address Section */}
            <Box sx={{ mb: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <HomeIcon sx={{ color: "#006D77", mr: 1, fontSize: 28 }} />
                <Typography variant="h6" sx={{ color: "#006D77", fontWeight: 600 }}>
                  Address Details
                </Typography>
              </Box>
              <Divider sx={{ mb: 3 }} />

              {editMode ? (
                 <Grid container spacing={3} 
                //  direction="column"
                 >
                 <Grid item xs={12} md={4}>
                    <TextField 
                      label="Full Name" 
                      value={formData.address.full_name} 
                      onChange={(e) => handleAddressChange("full_name", e.target.value)} 
                      // fullWidth 
                      variant="outlined"
                      error={!!errors.full_name}
                      helperText={errors.full_name}
                      size="small"
                      sx={{ backgroundColor: "white" }}
                    />
                  </Grid>
                 <Grid item xs={12} md={4}>
                    <TextField 
                      label="Phone Number" 
                      value={formData.address.phone} 
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                        handleAddressChange("phone", value);
                          const errorMsg = validatePhone(value);
                          setErrors(prev => ({
                            ...prev,
                            addressPhone: errorMsg
                          }));
                      }} 
                      fullWidth 
                      variant="outlined"
                      size="small"
                      error={!!errors.addressPhone}                 // 🔥 shows red border
                      helperText={errors.addressPhone}  
                      InputProps={{
                        startAdornment: <InputAdornment position="start">+91</InputAdornment>,
                      }}
                      sx={{ backgroundColor: "white" }}
                    />
                  </Grid>


                 <Grid item xs={12} md={4}>
                    <TextField
                      label="Community/Society Name"
                      value={formData.address.community_name}
                      fullWidth
                      size="small"
                      disabled
                      sx={{ backgroundColor: "#f9f9f9" }}
                    />
                </Grid>
               <Grid item xs={12} md={4}>
                  <TextField
                    select
                    label="Block"
                    value={formData.address.address_line1}
                    onChange={(e) => handleAddressChange("address_line1", e.target.value)}
                    placeholder="House/Flat No., Building Name"
                    fullWidth
                    size="small"
                    error={!!errors?.block}
                    helperText={errors?.block}
                 sx={{width:"200%"}}
                 disabled
                  >
                    <MenuItem value="">Select Community</MenuItem>
                    {BLOCK_OPTIONS.map((block) => (
                      <MenuItem key={block} value={block}>
                        {block}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>


                 <Grid item xs={12} md={4}>
                    <TextField 
                      label="Flat/House Number" 
                      type="number"
                      value={formData.address.address_line2} 
                      onChange={(e) => handleAddressChange("address_line2", e.target.value)} 
                      fullWidth 
                      variant="outlined"
                      size="small"
                      disabled
                      sx={{ backgroundColor: "white" }}
                    />
                  </Grid>
                 <Grid item xs={12} md={4}>
                    <TextField 
                      label="Landmark (Optional)" 
                      value={formData.address.landmark} 
                      onChange={(e) => handleAddressChange("landmark", e.target.value)} 
                      fullWidth 
                      variant="outlined"
                      size="small"
                      sx={{ backgroundColor: "white" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField 
                      label="City" 
                      value={formData.address.city} 
                      onChange={(e) => handleAddressChange("city", e.target.value)} 
                      fullWidth 
                      variant="outlined"
                      size="small"
                      sx={{ backgroundColor: "white" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField 
                      label="State" 
                      value={formData.address.state} 
                      onChange={(e) => handleAddressChange("state", e.target.value)} 
                      fullWidth 
                      variant="outlined"
                      size="small"
                      sx={{ backgroundColor: "white" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField 
                      label="Pincode" 
                      value={formData.address.pincode} 
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                        handleAddressChange("pincode", value);
                      }} 
                      fullWidth 
                      variant="outlined"
                      size="small"
                      sx={{ backgroundColor: "white" }}
                    />
                  </Grid>
                  <Grid item xs={12} sx={{display:"none"}}>
                    <TextField 
                      select
                      label="Address Type" 
                      value={formData.address.address_type} 
                      onChange={(e) => handleAddressChange("address_type", e.target.value)} 
                      fullWidth 
                      variant="outlined"
                      size="small"
                      sx={{ backgroundColor: "white" }}
                    >
                      <MenuItem value="home">Home</MenuItem>
                      <MenuItem value="work">Work</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                    </TextField>
                  </Grid>
                </Grid>
              ) : (
                formData.address.full_name ? (
                  <Box sx={{ p: 3, backgroundColor: "#f9f9f9", borderRadius: 1, border: "1px solid #e0e0e0" }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.5 }}>
                          {formData.address.full_name}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#666", mb: 1 }}>
                          +91 {formData.address.phone}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body2">
                          {formData.address.address_line1}
                          {formData.address.address_line2 && `, ${formData.address.address_line2}`}
                        </Typography>
                        <Typography variant="body2">
                          {formData.address.community_name}
                        </Typography>
                        {formData.address.landmark && (
                          <Typography variant="body2" sx={{ color: "#666", fontSize: "0.875rem" }}>
                            Landmark: {formData.address.landmark}
                          </Typography>
                        )}
                        <Typography variant="body2">
                          {formData.address.city}, {formData.address.state} - {formData.address.pincode}
                        </Typography>
                        <Chip 
                          label={formData.address.address_type} 
                          size="small" 
                          sx={{ mt: 1, backgroundColor: "#006D77", color: "white", textTransform: "capitalize",pointerEvents: "none", }} 
                        />
                      </Grid>
                    </Grid>
                  </Box>
                ) : (
                  <Typography variant="body2" sx={{ color: "#999", fontStyle: "italic", p: 2 }}>
                    No address added yet
                  </Typography>
                )
              )}
            </Box>

            {/* Emergency Contacts Section */}
            <Box sx={{ mb: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <ContactEmergencyIcon sx={{ color: "#006D77", mr: 1, fontSize: 28 }} />
                <Typography variant="h6" sx={{ color: "#006D77", fontWeight: 600 }}>
                  Emergency Contacts
                </Typography>
              </Box>
              <Divider sx={{ mb: 3 }} />

              {editMode ? (
                <>
                  {formData.emergency_contacts.map((contact, idx) => (
                    <Card key={idx} sx={{ mb: 2, p: 2, backgroundColor: "#fafafa", boxShadow: 1 }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={5}>
                          <TextField 
                            label="Contact Name" 
                            value={contact.name} 
                            onChange={(e) => handleEmergencyChange(idx, "name", e.target.value)} 
                            fullWidth
                            variant="outlined"
                            size="small"
                            sx={{ backgroundColor: "white" }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                        <TextField
                            label="Phone Number"
                            value={contact.phone}
                            onChange={(e) => {
                              const val = e.target.value;
                              // Allow only numbers and limit to 10 digits
                              if (/^\d{0,10}$/.test(val)) {
                                handleEmergencyChange(idx, "phone", val);
                                const errorMsg = validatePhone(val);
                                setErrors(prev => ({
                                  ...prev,
                                  alternatePhone: errorMsg
                                }));
                              }
                            }}
                            fullWidth
                            variant="outlined"
                            size="small"
                            error={!!errors.alternatePhone}                 // 🔥 shows red border
                            helperText={errors.alternatePhone}  
                            sx={{ backgroundColor: "white" }}
                            inputProps={{ maxLength: 10 }}
                          />

                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <IconButton 
                            color="error" 
                            onClick={() => {
                              const updated = formData.emergency_contacts.filter((_, i) => i !== idx);
                              setFormData({ ...formData, emergency_contacts: updated });
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Card>
                  ))}
                  <Button 
                    variant="outlined" 
                    sx={{ 
                      color: "#006D77", 
                      borderColor: "#006D77",
                      "&:hover": { borderColor: "#005a63", backgroundColor: "rgba(0, 109, 119, 0.04)" }
                    }} 
                    onClick={() => setFormData({ 
                      ...formData, 
                      emergency_contacts: [...formData.emergency_contacts, { name: "", phone: "" }] 
                    })}
                  >
                    + Add Emergency Contact
                  </Button>
                </>
              ) : (
                <Grid container spacing={2}>
                  {formData.emergency_contacts.filter(c => c.name && c.phone).map((contact, idx) => (
                    <Grid item xs={12} md={6} key={idx}>
                      <Box sx={{ p: 2, backgroundColor: "#f9f9f9", borderRadius: 1, border: "1px solid #e0e0e0" }}>
                        <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.5 }}>
                          {contact.name}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#666" }}>
                          {contact.phone}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Box>

            {/* Family Members Section */}
            <Box sx={{ mb: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <FamilyRestroomIcon sx={{ color: "#006D77", mr: 1, fontSize: 28 }} />
                <Typography variant="h6" sx={{ color: "#006D77", fontWeight: 600 }}>
                  Family Members
                </Typography>
              </Box>
              <Divider sx={{ mb: 3 }} />

              {editMode ? (
                <>
                  {formData.family_members.map((member, idx) => (
                    <Card key={idx} sx={{ mb: 2, p: 2, backgroundColor: "#fafafa", boxShadow: 1 }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={3}>
                          <TextField 
                            label="Name" 
                            value={member.name} 
                            onChange={(e) => handleFamilyChange(idx, "name", e.target.value)} 
                            fullWidth
                            variant="outlined"
                            size="small"
                            sx={{ backgroundColor: "white" }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <TextField 
                            label="Relation" 
                            value={member.relation} 
                            onChange={(e) => handleFamilyChange(idx, "relation", e.target.value)} 
                            fullWidth
                            variant="outlined"
                            size="small"
                            sx={{ backgroundColor: "white" }}
                          />
                        </Grid>
                        <Grid item xs={6} sm={2}>
                        <TextField
                          label="Age"
                          value={member.age}
                          onChange={(e) => {
                            const val = e.target.value;
                            // Allow only numbers and max 2 digits
                            if (/^\d{0,2}$/.test(val)) {
                              handleFamilyChange(idx, "age", val);
                            }
                          }}
                          fullWidth
                          variant="outlined"
                          size="small"
                          sx={{ backgroundColor: "white" }}
                          inputProps={{ maxLength: 2 }}
                        />

                        </Grid>
                        {/* <Grid item xs={6} sm={3}> */}
                        <Grid item xs={12} sm={4} md={4}>

                          <TextField 
                            select 
                            label="Gender" 
                            value={member.gender || ""} 
                            onChange={(e) => handleFamilyChange(idx, "gender", e.target.value)} 
                            fullWidth
                            variant="outlined"
                            size="small"
                            // sx={{ backgroundColor: "white" }}
                            sx={{ backgroundColor: "white", minWidth: 200, }}
                            
                            
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="male">Male</MenuItem>
                            <MenuItem value="female">Female</MenuItem>
                            <MenuItem value="other">Other</MenuItem>
                          </TextField>
                        </Grid>
                        <Grid item xs={12} sm={1}>
                          <IconButton 
                            color="error" 
                            onClick={() => {
                              const updated = formData.family_members.filter((_, i) => i !== idx);
                              setFormData({ ...formData, family_members: updated });
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Card>
                  ))}
                  <Button 
                    variant="outlined" 
                    sx={{ 
                      color: "#006D77", 
                      borderColor: "#006D77",
                      "&:hover": { borderColor: "#005a63", backgroundColor: "rgba(0, 109, 119, 0.04)" }
                    }} 
                    onClick={() => setFormData({ 
                      ...formData, 
                      family_members: [...formData.family_members, { name: "", relation: "", age: "", gender: "" }] 
                    })}
                  >
                    + Add Family Member
                  </Button>
                </>
              ) : (
                <Grid container spacing={2}>
                  {formData.family_members.filter(m => m.name && m.relation).map((member, idx) => (
                    <Grid item xs={12} md={6} key={idx}>
                      <Box sx={{ p: 2, backgroundColor: "#f9f9f9", borderRadius: 1, border: "1px solid #e0e0e0" }}>
                        <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                          {member.name}
                        </Typography>
                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                          <Chip label={member.relation} size="small" sx={{ backgroundColor: "#006D77", color: "white",pointerEvents: "none" }} />
                          <Chip label={`${member.age} years`} size="small" variant="outlined" sx={{pointerEvents: "none"}}/>
                          <Chip label={member.gender} size="small" variant="outlined" sx={{pointerEvents: "none"}} />
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Box>

            {/* Documents Section */}
            <Box sx={{ mb: 4,display:"none" }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <DescriptionIcon sx={{ color: "#006D77", mr: 1, fontSize: 28 }} />
                <Typography variant="h6" sx={{ color: "#006D77", fontWeight: 600 }}>
                  Documents
                </Typography>
              </Box>
              <Divider sx={{ mb: 3 }} />

              {editMode ? (
                <>
                  {formData.documents.map((doc, idx) => (
                    <Card key={idx} sx={{ mb: 2, p: 2, backgroundColor: "#fafafa", boxShadow: 1 }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={5}>
                          <TextField 
                            label="Document Name" 
                            placeholder="e.g., medical reports" 
                            value={doc.type} 
                            onChange={(e) => handleDocumentChange(idx, "type", e.target.value)} 
                            fullWidth
                            variant="outlined"
                            size="small"
                            sx={{ backgroundColor: "white" }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <Button 
                            variant="outlined" 
                            component="label" 
                            startIcon={<UploadFileIcon />} 
                            fullWidth
                            sx={{ 
                              borderColor: "#006D77", 
                              color: "#006D77",
                              "&:hover": { borderColor: "#005a63", backgroundColor: "rgba(0, 109, 119, 0.04)" }
                            }}
                          >
                            Upload Files
                            <input 
                              type="file" 
                              hidden 
                              multiple 
                              onChange={(e) => handleDocumentChange(idx, "files", e.target.files)}
                            />
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <IconButton 
                            color="error" 
                            onClick={() => {
                              const updated = formData.documents.filter((_, i) => i !== idx);
                              setFormData({ ...formData, documents: updated });
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                      {doc.file_url?.length > 0 && (
                        <Box sx={{ mt: 2, pl: 2 }}>
                          {doc.file_url.map((url, i) => (
                            <Chip 
                              key={i} 
                              label={url.split('/').pop() || url} 
                              size="small" 
                              sx={{ mr: 1, mb: 1,pointerEvents: "none" }} 
                              clickable
                              component="a"
                              href={url}
                              target="_blank"
                            />
                          ))}
                        </Box>
                      )}
                    </Card>
                  ))}
                  <Button 
                    variant="outlined" 
                    sx={{ 
                      color: "#006D77", 
                      borderColor: "#006D77",
                      "&:hover": { borderColor: "#005a63", backgroundColor: "rgba(0, 109, 119, 0.04)" }
                    }} 
                    onClick={() => setFormData({ 
                      ...formData, 
                      documents: [...formData.documents, { type: "", file_url: [] }] 
                    })}
                  >
                    + Add Document
                  </Button>
                </>
              ) : (
                <Grid container spacing={2}>
                  {formData.documents.filter(d => d.type).map((doc, idx) => (
                    <Grid item xs={12} key={idx}>
                      <Box sx={{ p: 2, backgroundColor: "#f9f9f9", borderRadius: 1, border: "1px solid #e0e0e0" }}>
                        <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                          {doc.type || "Document"}
                        </Typography>

                       {/* In your display section */}
                        {doc.file_url?.length > 0 ? (
                          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                            {doc.file_url.map((url, i) => (
                              <Chip
                                key={i}
                                label={url.split("/").pop() || `File ${i + 1}`}
                                size="small"
                                clickable
                                component="a"
                                href={url}
                                target="_blank"
                                sx={{
                                  backgroundColor: "#006D77",
                                  color: "white",
                                  "&:hover": { backgroundColor: "#005a63" }
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  window.open(url, '_blank');
                                }}
                              />
                            ))}
                          </Box>
                        ) : (
                          <Typography variant="body2" sx={{ color: "#999", fontStyle: "italic" }}>
                            No files uploaded
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Box>

            {/* Action Buttons */}
            {editMode && (
              <Box sx={{ display: "flex", gap: 2, mt: 4 }}>
                <Button 
                  variant="contained" 
                  startIcon={<SaveIcon />}
                  onClick={handleSaveProfile}
                    disabled={Object.values(errors || {}).some(val => val)}                  sx={{ 
                    flex: 1,
                    backgroundColor: "#006D77",
                    py: 1.5,
                    "&:hover": { backgroundColor: "#005a63" }
                  }}
                >
                  Save Changes
                </Button>
                <Button 
                  variant="outlined" 
                  startIcon={<CancelIcon />}
                  // onClick={() => setEditMode(false)}
                  onClick={handleCancelEdit}
                  sx={{ 
                    flex: 1,
                    borderColor: "#ccc",
                    color: "#666",
                    py: 1.5,
                    "&:hover": { borderColor: "#999", backgroundColor: "#f5f5f5" }
                  }}
                >
                  Cancel
                </Button>
              </Box>
            )}

            {/* Change Password Link */}
            <Box sx={{ mt: 4, pt: 3, borderTop: "1px solid #e0e0e0", textAlign: "center" }}>
              <Link 
                component="button" 
                underline="hover" 
                onClick={() => setPasswordDialog(true)} 
                sx={{ 
                  color: "#006D77", 
                  fontWeight: 500,
                  fontSize: "0.95rem"
                }}
              >
                Change Password
              </Link>
              <Divider orientation="vertical" flexItem />



            </Box>
          </CardContent>
        </Card>

        {/* Logout Confirmation Dialog */}
<Dialog
  open={logoutDialogOpen}
  onClose={() => setLogoutDialogOpen(false)}
  maxWidth="xs"
  fullWidth
  PaperProps={{ sx: { borderRadius: 2 } }}
>
  <DialogTitle sx={{ color: "#006D77", fontWeight: 600, pb: 1 }}>
    Confirm Logout
  </DialogTitle>
  <Divider />
  <DialogContent sx={{ pt: 2.5 }}>
    <Typography variant="body1" sx={{ color: "#444" }}>
      Are you sure you want to logout?
    </Typography>
  </DialogContent>
  <DialogActions sx={{ p: 2.5, pt: 1.5, gap: 1 }}>
    <Button
      onClick={() => setLogoutDialogOpen(false)}
      variant="outlined"
      sx={{
        textTransform: "none",
        borderColor: "#ccc",
        color: "#666",
        "&:hover": { borderColor: "#999", backgroundColor: "#f5f5f5" },
      }}
    >
      Cancel
    </Button>
    <Button
      onClick={handleLogout}
      variant="contained"
      sx={{
        textTransform: "none",
        backgroundColor: "#d32f2f",
        "&:hover": { backgroundColor: "#b71c1c" },
      }}
    >
      Yes, Logout
    </Button>
  </DialogActions>
</Dialog>

        {/* Password Dialog */}
        <Dialog 
          open={passwordDialog} 
          onClose={() => setPasswordDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ color: "#006D77", fontWeight: 600, pb: 1 }}>
            Change Password
          </DialogTitle>
          <Divider />
          <DialogContent sx={{ pt: 3 }}>
            <TextField 
              label="New Password" 
              type={showPassword.new ? "text" : "password"} 
              fullWidth 
              margin="normal"
              variant="outlined"
              value={passwordData.new_password} 
              onChange={(e) => setPasswordData({ ...passwordData, new_password: e.target.value })}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword({ ...showPassword, new: !showPassword.new })}>
                      {showPassword.new ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField 
              label="Confirm Password" 
              type={showPassword.confirm ? "text" : "password"} 
              fullWidth 
              margin="normal"
              variant="outlined"
              value={passwordData.confirm_password} 
              onChange={(e) => setPasswordData({ ...passwordData, confirm_password: e.target.value })}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword({ ...showPassword, confirm: !showPassword.confirm })}>
                      {showPassword.confirm ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 2 }}>
            <Button 
              onClick={() => setPasswordDialog(false)} 
              sx={{ color: "#666",textTransform:"none" }}
            >
              Cancel
            </Button>
            <Button 
              variant="contained" 
              onClick={handleChangePassword} 
              disabled={
                !passwordData.new_password || 
                !passwordData.confirm_password
              }
              sx={{ 
                backgroundColor: "#006D77",textTransform:"none",
                "&:hover": { backgroundColor: "#005a63" },
                opacity: (!passwordData.new_password || !passwordData.confirm_password) ? 0.5 : 1,
                cursor: (!passwordData.new_password || !passwordData.confirm_password) ? "not-allowed" : "pointer",
              }}
            >
              Update Password
            </Button>
          </DialogActions>
        </Dialog>

        {/* Validation Dialog */}
        <Dialog
          open={validationDialogOpen}
          onClose={() => setValidationDialogOpen(false)}
          maxWidth="sm"
        >
          <DialogTitle sx={{ color: "#006D77", fontWeight: 600 }}>
            Message
          </DialogTitle>
          <Divider />
          <DialogContent sx={{ pt: 3 }}>
            <Typography>{validationMessage}</Typography>
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 2 }}>
            <Button 
              variant="contained"
              onClick={() => setValidationDialogOpen(false)}
              sx={{ 
                backgroundColor: "#006D77",
                "&:hover": { backgroundColor: "#005a63" }
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    {/* </Box> */}
    </>
  );
};

export default ProfilePage;